import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate, formatMoney } from "../Helpers";
import { STR_BUY_NOW, STR_DAY, STR_DAYS, STR_PAID, STR_PURCHASE_SUBSCRIPTION_PACKAGE, STR_SUBSCRIPTION_HAS_EXPIRED, STR_UNPAID } from "../Strings";
import { MdCall, MdHotel, MdMessage, MdTimer, MdTimer10, MdTimeToLeave, MdWhatsapp } from "react-icons/md";
import { TbBrandDaysCounter } from "react-icons/tb";

export default function View({ data }) {
	const appContext = useContext(AppContext);

	/* Place states here */


	function view() {
		return;
		appContext.navTo({
			item: "view",
			subItem: "hotel-revenue",
			extraItem: data.id,
		});
	}

	return (
		<div 
			className=""
			style={{
				padding: "10px",
			}}
		>
			<h6
				style={{
					fontSize: "20px"
				}}
				className="font-semi-bold"
			>
				TZS {formatMoney(Math.floor(data.amount))}
			</h6>

			<span
				className={(data.status === 'success') ? "badge bg-success" : "badge bg-dark"}
			>
				{data.status}
			</span>

			<h6
				style={{
					fontSize: "12px"
				}}
				className="font-semi-bold text-muted text-end"
			>
				TZS {formatDate(data.dateCreated)}
			</h6>

			<hr/>
		</div>
	);
}
